import { render, staticRenderFns } from "./ModulesFormScreen.vue?vue&type=template&id=54e1105b&"
import script from "./ModulesFormScreen.vue?vue&type=script&lang=js&"
export * from "./ModulesFormScreen.vue?vue&type=script&lang=js&"
import style0 from "./ModulesFormScreen.vue?vue&type=style&index=0&id=54e1105b&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports